import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatErr } from "../lib/api";
import { toast } from "sonner";
import { Send, ArrowRight } from "lucide-react";

export default function TicketsTransfer() {
    const [form, setForm] = useState({
        qr_token: "", current_buyer_email: "",
        recipient_name: "", recipient_email: "",
    });
    const [submitting, setSubmitting] = useState(false);
    const [done, setDone] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        try {
            await api.post("/tickets/transfer", form);
            toast.success("Transferred. New QR sent to the recipient.");
            setDone(true);
        } catch (err) {
            toast.error(formatErr(err));
        } finally { setSubmitting(false); }
    };

    return (
        <div data-testid="tickets-transfer-page" className="grain">
            <section className="border-b border-line py-16 md:py-24 bg-bg-soft">
                <div className="max-w-7xl mx-auto px-5 md:px-10">
                    <div className="text-gold text-xs tracking-[0.4em] uppercase font-bold mb-4">Pass The Crown</div>
                    <h1 className="h-display text-6xl md:text-8xl">Transfer Tickets</h1>
                    <p className="text-ink text-lg mt-5 max-w-xl">Send your seats to a friend. The old QR is invalidated; the new one arrives at their inbox.</p>
                </div>
            </section>

            <section className="max-w-3xl mx-auto px-5 md:px-10 py-16">
                {!done ? (
                    <form onSubmit={submit} className="card-flat p-8 space-y-5" data-testid="transfer-form">
                        <div>
                            <label className="text-[10px] tracking-widest uppercase text-ink font-bold">QR Token (from your receipt email)</label>
                            <input required value={form.qr_token} onChange={(e) => setForm({ ...form, qr_token: e.target.value })} data-testid="tr-token" placeholder="e.g. K9pX4mZ_…" className="w-full mt-2 px-4 py-3 text-sm font-mono" />
                        </div>
                        <div>
                            <label className="text-[10px] tracking-widest uppercase text-ink font-bold">Your Email (must match the original purchase)</label>
                            <input required type="email" value={form.current_buyer_email} onChange={(e) => setForm({ ...form, current_buyer_email: e.target.value })} data-testid="tr-current-email" className="w-full mt-2 px-4 py-3 text-sm" />
                        </div>
                        <div className="border-t border-line pt-5">
                            <div className="text-gold text-[10px] tracking-widest uppercase font-bold flex items-center gap-2 mb-4">
                                <ArrowRight size={12} /> Recipient
                            </div>
                            <div className="grid sm:grid-cols-2 gap-4">
                                <div>
                                    <label className="text-[10px] tracking-widest uppercase text-ink font-bold">Their Name</label>
                                    <input required value={form.recipient_name} onChange={(e) => setForm({ ...form, recipient_name: e.target.value })} data-testid="tr-recipient-name" className="w-full mt-2 px-4 py-3 text-sm" />
                                </div>
                                <div>
                                    <label className="text-[10px] tracking-widest uppercase text-ink font-bold">Their Email</label>
                                    <input required type="email" value={form.recipient_email} onChange={(e) => setForm({ ...form, recipient_email: e.target.value })} data-testid="tr-recipient-email" className="w-full mt-2 px-4 py-3 text-sm" />
                                </div>
                            </div>
                        </div>
                        <button type="submit" disabled={submitting} data-testid="tr-submit" className="btn-gold px-7 py-4 text-xs disabled:opacity-60 inline-flex items-center gap-2">
                            <Send size={14} /> {submitting ? "Transferring…" : "Transfer Ticket"}
                        </button>
                        <p className="text-[10px] text-ink uppercase tracking-widest">
                            Cannot transfer used or revoked tickets. One-way; old QR stops working immediately.
                        </p>
                    </form>
                ) : (
                    <div className="card-flat p-10 text-center" data-testid="transfer-done">
                        <Send className="text-gold mx-auto" size={36} />
                        <h2 className="h-display text-3xl mt-5">Transferred.</h2>
                        <p className="text-white/80 mt-3">A new QR has been emailed to the recipient. Your previous QR no longer works.</p>
                        <Link to="/" className="btn-gold px-7 py-4 mt-6 inline-block text-xs">Done</Link>
                    </div>
                )}
            </section>
        </div>
    );
}
